import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import java from "../assets/java.png";
import spring from "../assets/spring.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";

import redux from "../assets/redux.png";

import sass from "../assets/sass.png";
import circle from "../assets/circle.svg";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";

import newLogoWhite from "../assets/kmlogowhite.png";
import newLogoPurple from "../assets/kmlogopurple-cropped.png";
import newLogoBlack from "../assets/kmlogoblack.png";
import kmgradient from "../assets/kmgradient.png";
import gradientbg from "../assets/gradient-bg.png";

const images = {
  email,
  mobile,
  api,
  css,
  git,
  html,
  javascript,
  react,
  redux,
  sass,
  circle,
  bolt,
  nb,
  skype,
  spotify,
  newLogoWhite,
  newLogoBlack,
  newLogoPurple,
  java,
  spring,
  kmgradient,
  gradientbg,
};

export default images;
